import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

export const FileTypeCsvIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    className={cn(className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M4.49444 13.8576C9.613 14.7454 14.7317 14.7155 19.8502 13.8576V6.7415C19.8502 6.66042 19.824 6.58159 19.7753 6.51678L16.4046 2.0224C16.3338 1.92811 16.2228 1.87256 16.105 1.87256H5.61804C5.32006 1.87256 5.03422 1.99094 4.82352 2.20164C4.61282 2.41242 4.49444 2.69818 4.49444 2.99615V11.6104C4.49444 12.1667 4.36401 12.6381 4.36401 13.014C4.36401 13.5335 4.49444 13.8576 4.49444 13.8576Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M2.24719 12.8867V20.9737C2.24719 21.2716 2.36557 21.5575 2.57627 21.7682C2.78697 21.9789 3.07281 22.0973 3.37079 22.0973H20.5993C20.8973 22.0973 21.183 21.9789 21.3938 21.7682C21.6045 21.5575 21.7229 21.2716 21.7229 20.9737C21.7229 19.5385 21.7229 16.4164 21.7229 14.9812C21.7229 14.6832 21.6045 14.3974 21.3938 14.1867C21.183 13.976 20.8973 13.8576 20.5993 13.8576H3.74535C3.26751 13.8576 2.24719 12.8867 2.24719 12.8867Z"
      fill="#D8A52F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M3.37079 13.8577C3.02886 13.8577 2.77924 13.719 2.59551 13.5482C2.42265 13.3875 2.24719 13.1042 2.24719 12.7341C2.24719 12.4965 2.36557 12.1502 2.57627 11.9396C2.78697 11.7289 3.07281 11.6105 3.37079 11.6105H4.49438V13.8577C4.49438 13.8577 4.59065 13.8577 3.37079 13.8577Z"
      fill="#A07511"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.1049 1.87256V5.61791C16.1049 5.91588 16.2232 6.20173 16.4339 6.41242C16.6446 6.62312 16.9304 6.7415 17.2285 6.7415H19.8501C19.8501 6.66042 19.8239 6.58159 19.7752 6.51678L16.4045 2.0224C16.3337 1.92811 16.2227 1.87256 16.1049 1.87256Z"
      fill="#AFBDC7"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M7.86516 7.11607H12.7341C12.9408 7.11607 13.1086 6.94825 13.1086 6.74151C13.1086 6.53476 12.9408 6.36694 12.7341 6.36694H7.86516C7.65842 6.36694 7.4906 6.53476 7.4906 6.74151C7.4906 6.94825 7.65842 7.11607 7.86516 7.11607Z"
      fill="#D8A52F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M7.86516 9.36326H16.4794C16.6861 9.36326 16.8539 9.19544 16.8539 8.9887C16.8539 8.78196 16.6861 8.61414 16.4794 8.61414H7.86516C7.65842 8.61414 7.4906 8.78196 7.4906 8.9887C7.4906 9.19544 7.65842 9.36326 7.86516 9.36326Z"
      fill="#D8A52F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M7.86516 11.6105H16.4794C16.6861 11.6105 16.8539 11.4426 16.8539 11.2359C16.8539 11.0291 16.6861 10.8613 16.4794 10.8613H7.86516C7.65842 10.8613 7.4906 11.0291 7.4906 11.2359C7.4906 11.4426 7.65842 11.6105 7.86516 11.6105Z"
      fill="#D8A52F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M14.0718 16.244L15.5699 19.9893C15.6267 20.1315 15.7645 20.2247 15.9176 20.2247C16.0708 20.2247 16.2085 20.1315 16.2654 19.9893L17.7635 16.244C17.8403 16.0521 17.7468 15.8339 17.5548 15.7571C17.3629 15.6804 17.1448 15.7739 17.068 15.9658L15.9176 18.8417L14.7672 15.9658C14.6905 15.7739 14.4723 15.6804 14.2804 15.7571C14.0885 15.8339 13.995 16.0521 14.0718 16.244Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M8.26634 15.7303H8.05232C7.01807 15.7303 6.17969 16.5687 6.17969 17.603V18.3521C6.17969 19.3863 7.01807 20.2247 8.05232 20.2247H8.26634C8.93447 20.2247 9.54122 19.835 9.81897 19.2273C9.85771 19.1427 9.86535 19.1267 9.89025 19.0715C9.98832 18.8538 9.86993 18.655 9.72935 18.5844C9.49456 18.4663 9.28153 18.5971 9.20899 18.76C9.18697 18.8094 9.13771 18.916 9.13771 18.916C8.98175 19.2569 8.64135 19.4757 8.26634 19.4757H8.05232C7.43173 19.4757 6.92872 18.9726 6.92872 18.3521V17.603C6.92872 16.9825 7.43173 16.4794 8.05232 16.4794H8.26634C8.64135 16.4794 8.98175 16.6982 9.13771 17.0391C9.13771 17.0391 9.18337 17.1414 9.20899 17.1951C9.32153 17.4309 9.5876 17.4645 9.75587 17.3552C9.87407 17.2782 9.98571 17.0924 9.89025 16.8836C9.81897 16.7277 9.81897 16.7277 9.81897 16.7277C9.54122 16.1201 8.93447 15.7303 8.26634 15.7303Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M10.4869 18.9162V19.1019C10.4869 19.3996 10.6052 19.6853 10.8157 19.8958C11.0264 20.1064 11.3119 20.2247 11.6097 20.2247H12.454C12.7517 20.2247 13.0373 20.1064 13.2479 19.8958C13.4585 19.6853 13.5768 19.3996 13.5768 19.1019C13.5768 19.0515 13.5768 19.0015 13.5768 18.9528C13.5768 18.4934 13.2971 18.0803 12.8705 17.9096L11.5086 17.3649C11.3439 17.299 11.236 17.1395 11.236 16.9622V16.8539C11.236 16.7546 11.2754 16.6593 11.3456 16.5891C11.4159 16.5188 11.5111 16.4794 11.6104 16.4794H12.4532C12.5526 16.4794 12.6478 16.5188 12.718 16.5891C12.7882 16.6593 12.8277 16.7546 12.8277 16.8539V17.0389C12.8277 17.1446 12.8744 17.2403 12.9215 17.2888C12.9945 17.3718 13.0995 17.4157 13.2023 17.4157C13.3846 17.4157 13.5768 17.275 13.5768 17.0389V16.8539C13.5768 16.556 13.4584 16.2701 13.2477 16.0594C13.037 15.8487 12.7512 15.7303 12.4532 15.7303H11.6105C11.3125 15.7303 11.0267 15.8487 10.816 16.0594C10.6053 16.2701 10.4869 16.556 10.4869 16.8539V16.9622C10.4869 17.4458 10.7814 17.8807 11.2304 18.0603L12.5923 18.6051C12.7345 18.6619 12.8277 18.7997 12.8277 18.9528V19.1019C12.8277 19.201 12.7883 19.2961 12.7182 19.3662C12.6482 19.4363 12.5531 19.4757 12.454 19.4757H11.6097C11.5106 19.4757 11.4156 19.4363 11.3455 19.3662C11.2753 19.2961 11.236 19.201 11.236 19.1019C11.236 19.1019 11.236 19.1019 11.236 18.9161C11.236 18.6691 11.0346 18.5392 10.868 18.5392C10.7099 18.5392 10.4869 18.6617 10.4869 18.9139V18.9162Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
  </svg>
);

export default FileTypeCsvIcon;
